import { Annex, ChannelType } from '@models/enums';

/**
 * This is the object representing all meta data for any upstream or downstream channel.
 * For channel scan measurements, see the extension object ChannelData
 */
export class Channel {
  channelId: string;
  name: string;
  freq: number;
  frequency: number;
  symbolRate: number;
  locked: boolean;
  qam: string;
  type: ChannelType;
  annex: Annex;
  content: string[];

  /**
   * We're using the empty constructor for Channel object.  Explicitly adding the constructor here to indicate it's usage.
   */
  constructor() { }

  /**
   * This is a static function being treated like a constuctor where we pass in a list of arguments and create a new instance.
   * We're also using the empty constructor, and overloaded constructors are not supported by Typescript
   *
   * @param frequency
   * @param channelId
   * @param symbolRate
   * @param content
   * @param channelType
   */
  static getChannel(frequency: number, channelId: string, symbolRate: number, content: string[], channelType: ChannelType, name: string): Channel {
    const channel = new Channel();
    channel.frequency = frequency;
    channel.channelId = channelId;
    channel.symbolRate = symbolRate;
    channel.name = name;
    channel.content = content;
    return channel;
  }
}


